import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Header } from "../components/header/Header";
import { Menu } from "../components/menu/Menu";
import { Footer } from "../components/footer/Footer";

import { Traceability } from "../pages/traceability";

import { User } from "../app/user/userSlice";
import { useSelector } from "react-redux";

let menutiems = [
  {
    text: "Órdenes",
    id: "6",
    check: false,
  },
  {
    text: "Subir Órdenes",
    id: "7",
    check: false,
  },
  {
    text: "Archivos en Error",
    id: "8",
    check: false,
  },
];

export const PrivateRoute = () => {
  const [openMenu, setOpenMenu] = useState(false);
  const user = useSelector(User);
  const [, setOptionsMenu] = useState(null);
  const [check] = useState(false);

  const handelOpenMenu = () => {
    setOpenMenu(!openMenu);
  };

  const getEmail = JSON.parse(localStorage.getItem("dbhuseread"));

  const { username } = getEmail;

  if(window.location.pathname === '/') {
    window.location.replace('/consultation');
  }

  useEffect(() => {
    const getPermisos = menutiems?.map((permisoMenu) => {
      let findPermisos = user?.permisosMenu?.find(
        (permiso) => permisoMenu.id === permiso.idPermiso
      );
      if (findPermisos != null) {
        permisoMenu.check = true;
      }
      return permisoMenu;
    });
    setOptionsMenu(getPermisos);
  }, [user, check]);

  useEffect(() => {}, [username]);

  return (
    <BrowserRouter>
      <div className="main-container">
        <Header />
        <div className="main-container__content">
          <div
            className={`${
              openMenu
                ? "main-container__menu-open"
                : "main-container__menu-close"
            }`}
          >
            <Menu openMenu={openMenu} handelOpenMenu={handelOpenMenu} />
          </div>
          <div
            className={`${
              openMenu
                ? "main-container__main-content-small"
                : "main-container__main-content-big"
            }`}
          >
            <Routes>
              <Route path="/consultation" element={<Traceability />} />
              <Route
                path="/login"
                element={<Navigate replace to="/consultation" />}
              />
            </Routes>
          </div>
        </div>
        <Footer />
      </div>
    </BrowserRouter>
  );
};
